import React from "react"
import { withStyles, WithStyles, createStyles } from "@material-ui/core"
import loadable from "@loadable/component"

import Sections from "./Sections"
import Copyright from "./Copyright"
import Background from "./Background"
import PageContainer from "../../PageContainer"
import CallToAction from "./CallToAction"

const Contact = loadable(() => import("./Contact"))

const styles = () => {
  return createStyles({
    root: {
      position: "relative",
      overflowX: "hidden",
    },
    container: {
      paddingBottom: "2.2813rem",
    },
  })
}

interface Props extends WithStyles<typeof styles> {
  callToAction?: JSX.Element
}

const Footer = ({ classes, callToAction = <CallToAction /> }: Props) => {
  return (
    <footer className={classes.root}>
      <PageContainer className={classes.container}>
        <Background />
        {callToAction}
        <Contact />
        <Sections />
        <Copyright />
      </PageContainer>
    </footer>
  )
}

export default withStyles(styles)(Footer)
